<template>
<div>
    <div id="app-background"></div>

    <div id="app">
        <main-nav />

        <breadcrumbs />

        <main id="main">
            <router-view></router-view>
        </main>
    </div>

    <component v-if="activeModal !== null" :is="activeModal" v-bind="modalProps" v-on="modalEvents" @close="activeModal = null" />

    <modal v-for="modal in modals" :key="modal.id"
        :state="modal.state"
        :no-footer="true"
        @close="$modalManager.remove(modal.id)">
        <template slot="header">
            <div v-html="modal.header"></div>
        </template>

        <template slot="content">
            <div v-html="modal.body"></div>

            <div class="flex jc-fe mt-1">
                <button class="medium" type="button" @click="$modalManager.remove(modal.id)">Close</button>
            </div>
        </template>
    </modal>

    <out-of-date-message :show="outOfDate" />
    <scheduled-maintenance-message :scheduled-date="scheduledMaintenanceDate" />

    <toast></toast>
</div>
</template>

<script>
import http from "@/http"
import store from "@/store"
const packageConfig = require("../../package.json")

export default {
    name: "App",

    data () {
        return {
            activeModal: null,
            appStatusIntervalId: null,
            modals: [],
            modalEvents: {},
            modalProps: {},
            outOfDate: false,
            permissions: [],
            scheduledMaintenanceDate: null,
            timeWentIdle: null
        }
    },

    computed: {
        token () {
            return store.getters.activeToken
        }
    },

    async created () {
        if (!this.token) {
            if (this.$route.path !== "/login") {
                this.$router.push("/login")
            }
        }

        this.$modalManager.onUpdate(modals => {
            this.modals = modals
        })

        if (this.appStatusIntervalId === null) {
            this.appStatusIntervalId = setInterval(this.getAppStatus, 1000 * 60 * 3)
        }

        this.getAppStatus()

        this.$eventManager.on("show-modal", ({ component, events, props }) => {
            this.activeModal = component
            this.modalEvents = events || {}
            this.modalProps = props
        })
    },

    watch: {
        "$route": function (to, from) {
            if (!this.token && !to.meta.public) {
                this.$router.push("/login")
            }
        }
    },

    onIdle () {
        this.timeWentIdle = new Date()
    },

    onActive () {
        if (this.timeWentIdle !== null) {
            const now = new Date()
            const difference = now - this.timeWentIdle
            const differenceHours = difference / 1000 / 60 / 60

            if (differenceHours >= 4) {
                console.log("Activating after 4 hours, refreshing the page")
                window.location.reload()
            }
        }
    },

    methods: {
        async getAppStatus () {
            const {
                data: {
                    scheduled_maintenance_date: scheduledMaintenanceDate,
                    version
                }
            } = await http("/api/app/status")

            this.outOfDate = parseInt(packageConfig.version.replace(/\./g, "")) < parseInt(version.replace(/\./g, ""))
            this.scheduledMaintenanceDate = scheduledMaintenanceDate
        }
    }
}
</script>

<style>
@import url("./assets/css/general.css");
@import url("./assets/css/flexbox.css");
@import url("./assets/css/buttons.css");
@import url("./assets/css/inputs.css");
@import url("./assets/css/tables.css");
@import url("./assets/css/tabs.css");

#app {
    position: relative;
    z-index: 2;
}

#app-background {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAgMAAAD90d5fAAAACVBMVEX29vb6+vr4+PjTp/ZNAAACDElEQVR42uyasQ3CQBAE10gEFEAJlLSIkFJogn6R3iG6AOn+sM8TOZjkpf33rUYnSbZf0tV+Smf7IS32PRec1s978Nvgl8HzQMgzQcgTQcizQHkkWvl18PPgSwogkiO/Ege3IxMoOsqSCFTwSi4qiOSmkCcChTwRaH4ki1UQiRUeJRGoIBKrIBKrIBIr5IlAJWNreiTdxlZJkyCSjUbSptx93Y5UIAdHSQTx1T4lAs2NpGe5m/vjsgoiscKjJAIVRGIVRGLNj6RbuZsbSc+xNbtJ9IoEc3fMcoe5w9xh7jB3mDvMHZoIc0ckjcod5g5zh7nD3GHu/lLu4p271++AnTuaBOZuH5F0eCWYO8wd5g5zh7nD3O1obGHujhxJm3KHucPcYe4wd5g7du52NLbYucPcUe4wd5g7zB3mDnO32XKHudvc2MLcHTmSNuUOc4e5w9xh7jB37Nx92rUDGgBgGARg/l1fxgdUA1kgzYJqy5Igd9GRNFwJuSN35I7ckTtyF1Rb5G45kppxR+7IHbkjd+TOz11Qbfm5I3fGHbkjd+SO3JG7s+OO3J2rLXK3HEnNuCN35I7ckTty5+cuqLYsCXIXHUnDlZA7ckfuyB25I3dBtUXuliOpGXfkjtyRO3JH7vzcBdWWnztyZ9yRO3JH7sgduTs77sjdudoid8uR1Iw7ckfuyB25I3dfxt0DbvH+1ADeV9kAAAAASUVORK5CYII=);
    background-repeat: repeat;
    height: 100%;
    left: 0;
    opacity: 0.55;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;
}

#main {
    padding: 25px;
    position: relative;
    overflow: auto;
}

#main-nav {
    background: rgba(0, 255, 137, 0.45);
    border-bottom: 1px solid #7ed5ad;
    box-shadow: 0px 0px 4px #77c5a1;
    color: #686868;
    min-height: 100px;
    padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue